import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Modal, Row, Select, Button } from 'antd';
const { confirm } = Modal;

const TaxModal = ({ form, offVisible, fetchData, visibility, selectedTax, onSubmit, resetSelectedTax, onDelete }) => {
  const [taxType, setTaxType] = useState('');
  useEffect(() => {
    if (selectedTax) {
      form.setFieldsValue({
        name: selectedTax.name,
        type: selectedTax.type,
        amount: selectedTax.amount
      });
      setTaxType(selectedTax.type);
    } else {
      form.resetFields();
    }
  }, [selectedTax]);

  const handleOk = async e => {
    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values, !selectedTax ? 'new' : selectedTax._id);
        form.resetFields();
        offVisible();
        resetSelectedTax();
      }
    });
  };

  const handleCancel = e => {
    offVisible();
    resetSelectedTax();
  };

  const handleConfirmDelete = () => {
    confirm({
      title: 'Are you sure you want to delete this tax?',
      content: 'This action cannot be undone.',
      onOk() {
        handleDelete();
        resetSelectedTax();
      },
      onCancel() {
        console.log('Cancel');
      }
    });
  };

  const handleDelete = () => {
    offVisible();
    onDelete(selectedTax._id);
  };

  const { getFieldDecorator } = form;

  return (
    <Modal
      title={!selectedTax ? 'New Tax' : selectedTax.name}
      visible={visibility}
      onCancel={handleCancel}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <Button key="submit" type="primary" onClick={handleOk}>
              {!selectedTax ? 'Create' : 'Update'}
            </Button>
          </div>
          {selectedTax && (
            <Button key="delete" type="danger" onClick={handleConfirmDelete}>
              Delete
            </Button>
          )}
        </div>
      }
    >
      <Form autoComplete="off">
        <Form.Item label="Tax Name">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Please input Tax Name' }]
          })(<Input placeholder="Tax Name" />)}
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tax Type">
              {getFieldDecorator('type', {
                rules: [{ required: true, message: 'Please select Tax Type' }]
              })(
                <Select placeholder="Select Type" onChange={value => setTaxType(value)}>
                  <Select.Option value="percentage">Percentage</Select.Option>
                  <Select.Option value="amount">Fixed Amount</Select.Option>
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label={taxType === 'percentage' ? 'Percentage' : 'Amount'}>
              {getFieldDecorator('amount', {
                rules: [
                  { required: true, message: `${`Please input Tax`} ${taxType === 'percentage' ? 'Percentage' : 'Amount'}` },
                  {
                    pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                    message: 'Please enter valid numbers and 2 decimal places only'
                  }
                ]
              })(
                <Input
                  placeholder={`${`Tax`} ${taxType === 'percentage' ? 'Percentage' : 'Amount'}`}
                  addonAfter={taxType === 'percentage' ? '%' : ''}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Form.create()(TaxModal);
